export enum TrainingTemplateStatus {
    DRAFT = "draft",
    READY = "ready",
    PUBLISHED = "published",
    ARCHIVED = "archived",
}

export default TrainingTemplateStatus;
